export default __webpack_public_path__ + "static/media/icon-send.865712b4.svg";